import React,{useRef, useState, useEffect} from "react";
import { Button, Row, Col} from "react-bootstrap";
import Select from "react-select";
import Rainbow from 'rainbowvis.js';
import ColorPicker from "../components/ColorPicker";
import PaletteSelector from "../components/PaletteSelector";
import { useContextMenu, contextMenu, Menu, Item } from 'react-contexify';

class StyleParam extends React.Component {

	
	constructor(props) {
		
		super(props);
		
		this.baseRule = [
			'case',
			'#889ADD'
		];
		this.baseColors = [
			'black',
			'red'
		];
		
		const options = this.processOptions(this.props.params);
		
		this.state = {
			...{
				options:options,
				rules:[],
				editRules:false,
				currentParam:false,
				previousColor:this.props.color,
				showPalette:false
			},
			...this.readRules(options)
		};
		this.readRules();
	}
	
	readRules(options){
		var sw = {rules:[]};
		if(!Array.isArray(this.props.color) || !options)
			return sw;
		
		var current = [...this.props.color];
		
		//get the property the rule is based on
		if(current[1] && current[1][1] && current[1][1][1]){
			const c = current[1][1][1];
			const idx = options.findIndex((p)=>{return p.value == c});
			if(idx != -1)
				sw.currentParam = options[idx];
		}
		//remove the "case" and default color
		current.shift();
		current.pop();
		for (let i = 0; i < current.length; i++){
			const r = current[i];
			
			sw.rules.push({label:r[2], value:r[2], color:current[++i]});
		};
		return sw
	}

	


	processOptions(params){
		
		if(!params)
			return [];
		
		var options = params.map((p)=>{
			return {label: p.name, value: p.name, legend:p.values.slice(0,3).join(", ")};
		});
		
		return options;
	}

	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}
	handleDoubleClick(e){


	}
	handleInputClick(e){
		
	}
	handleOnBlur(e){
		
	}
	handleOnChange(e){
		
	}

	componentDidUpdate(){
		
	}
	customOption(data){
		return (<div className="style-param-option">
		   <span>{data.label}</span>
		   <span className="style-param-option-legend">{data.legend}</span>
		</div>);
	}
	
	handleParamSelect(opt){
		
		if(!opt){
			this.updateRules([], false);
			return;
		}
		
		var idx = this.props.params.findIndex((o)=>{return o.name == opt.value });
		

		
		if(idx != -1){
			//if(this.props.onSelect)
			//this.props.onSelect(this.props[idx]);
			this.updateRules(this.makeRules(this.props.params[idx]), opt);
		}		
	}
	handleEditRules(){
		this.updateStatus({editRules:!this.state.editRules});
	}
	changeColor(idx, hex, parameter){
		
		var r = [...this.state.rules];
		
		r[idx].color = hex;
		
		this.updateRules(r, parameter);
	}
	updateRules(r, param){
		
		if(this.props.onChange){
			
			var styleRule = this.generateCode(r, param ? param.value : this.state.currentParam.value);
			this.props.onChange(styleRule);
		
		}
		
		this.updateStatus({rules: r, currentParam:(param !== null ? param : false)});
	}
	generateCode(rules, param){

		if(!rules.length)
			return "#000000";
		
		var code = [...this.baseRule];
		rules.forEach((r)=>{
			
			code.splice(1,0,['==', ['get', param], r.value], r.color);
			
		});
		
		return code;
		
	}
	changePalette(e ){
		this.updateStatus({showPalette:e});
	}
	applyPalette(param, palette){
		
		var idx = this.props.params.findIndex((o)=>{return o.name == param.value });
		

		
		if(idx != -1)
			this.updateRules(this.makeRules(this.props.params[idx], palette), param);
	}
	makeRules(param, palette){
		var colors = new Rainbow();
		colors.setSpectrum.apply(colors, palette ? palette : this.baseColors);
		colors.setNumberRange(0, param.values.length);
		
		
		var rules = param.values.map((value, idx)=>{
			return {label:value, value:value, color:"#"+colors.colourAt(idx)};
		});
		
		return rules;
	}
	handleReorder(o, idx, currentParam){
		
		//A[x] = A.splice(y, 1, A[x])[0];
		
		var n = [...this.state.rules];
		
		var fromIdx = n.findIndex((i)=>{return i.value == o.value});
		
		const a = n[fromIdx].value.toString();
		n[fromIdx].value = n[fromIdx].label = n[idx].value.toString();
		n[idx].value = n[idx].label = a;
		
		this.updateRules(n, currentParam);
		
	}
	render() {
		
		
		return (
			<>
				<div>
					<Select onChange={(o)=>{this.handleParamSelect(o);}} value={this.state.currentParam} isClearable={true} formatOptionLabel={this.customOption} options={this.state.options} />
				</div>

				{!!this.state.currentParam && 
					<div className="spectrum">
						<div className="gradient">
							{
								this.state.rules.map((rule, k)=>{
									return (<div key={k} className="tile" title={rule.label} style={{backgroundColor:rule.color}}></div>);
								})
							}
						</div>
						<div className="options">
							<i title="Edit pallete" className="ri-pencil-line" onClick={(e)=>{this.handleEditRules();}}></i>
							<i title="Choose another pallete" onClick={(e)=>{this.changePalette(this.state.showPalette ? false:e);}} className="ri-palette-line"></i>
						</div>
					</div>
				}
				<div className="rules-wrapper">
				{this.state.editRules && 
					
					this.state.rules.map((r, idx)=>{
						return (
						<Row key={idx} className="rule-color">
							<Col xs="2">
								<ColorPicker key={idx} hideHex={true} onChange={(hex)=>{this.changeColor(idx, hex, this.state.currentParam)}} color={r.color} />
							</Col>
							<Col xs="10">
								<Select className="react-select-container" classNamePrefix="react-select" onChange={(o)=>{this.handleReorder(o, idx, this.state.currentParam);}} value={r} isClearable={false} options={this.state.rules} />
							</Col>
						</Row>
						)
					})
					
				}
				</div>
				{
				!!this.state.showPalette &&
				<PaletteSelector show={this.state.showPalette} onClose={(e)=>{this.updateStatus({showPalette:false})}} onSelect={(palette)=>{this.applyPalette(this.state.currentParam, palette)}} />
				}
				
			</>
			
		);
			
		
	}
}

export default StyleParam;